<template lang="pug">
.header#app-header(:class="{ sticky: !isEventLandingPage && !isExhibitionsPage }")
  .container
    .header__wrap
      template(v-if="$vuetify.breakpoint.mdAndUp")
        template(v-if="isEventLandingPage || isExhibitionsPage")
          logo-heading
        template(v-if="!isEventLandingPage && !isExhibitionsPage")
          navigation-panel.flex-grow-1(
            :show-search="showSearchEventsField"
            @switchSearch="switchShowSearchEventsField"
          )
        template(v-else-if="isEventsSearchPage")
          v-spacer
        //- template(v-if="!isEventLandingPage")
        //-   profile-total-score
        template(v-if="isEventLandingPage && event")
          organizer-contacts.mr-auto(
            :organization="event.organization || {}"
          )
        profile-menu(@exit="onAccountExit")
      template(v-else-if="$vuetify.breakpoint.sm")
        template(v-if="isEventLandingPage || isExhibitionsPage")
          logo-heading
        template(v-if="!isEventLandingPage && !isExhibitionsPage")
          navigation-panel.flex-grow-1(
            :show-search="showSearchEventsField"
            @switchSearch="switchShowSearchEventsField"
          )
        template(v-else)
          v-spacer
        profile-menu(mini @exit="onAccountExit")
      template(v-else)
        .header__logo-wrap--sm.align-center
          template(v-if="isEventLandingPage || isExhibitionsPage")
            logo-heading
          template(v-if="!isEventLandingPage && !isExhibitionsPage")
            navigation-panel.flex-grow-1(
              :show-search="showSearchEventsField"
              @switchSearch="switchShowSearchEventsField"
            )
          template(v-if="$user.isAuthenticated")
            profile-activator(
              v-model="expand"
              mini
            )
          template(v-else)
            profile-activator(
              @click.native="$router.push({ name: 'login' })"
            )
    template(v-if="!isEventLandingPage && !isEventsSearchPage && !isExhibitionsPage && $vuetify.breakpoint.mdAndUp")
      v-expand-transition
        v-sheet.header__wrap(
          v-show="showSearchEventsField"
          :class="{ 'my-5': showSearchEventsField }"
          width="77%"
          height="unset"
        )
          search-events-field
    template(v-if="isEventLandingPage")
      .header__wrap
        event-landing-header-content(
          :event="event"
        )
    template(v-if="isExhibitionsPage")
      .header__wrap
        event-landing-header-content(
          :event="event"
        )
    v-expand-transition
      template(v-if="expand")
        mini-header-content(
          @exit="onAccountExit"
        )
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LogoHeading from './LogoHeading.vue';
import ProfileMenu from './ProfileMenu.vue';
import ProfileActivator from './ProfileActivator.vue';
import ProfileTotalScore from './ProfileTotalScore.vue';
import SearchEventsField from './SearchEventsField.vue';
import NavigationPanel from './Navigation.vue';
import MiniHeaderContent from './MiniHeaderContent.vue';
import EventLandingHeaderContent from './EventLandingHeaderContent.vue';
import OrganizerContacts from './OrganizerContacts.vue';

export default {
  name: 'TheHeader',
  components: {
    LogoHeading,
    ProfileMenu,
    ProfileActivator,
    NavigationPanel,
    SearchEventsField,
    ProfileTotalScore,
    MiniHeaderContent,
    EventLandingHeaderContent,
    OrganizerContacts,
  },
  data() {
    return {
      showSearchEventsField: false,
      expand: false,
    };
  },
  computed: {
    ...mapGetters({
      event: 'eventConstructor/getEvent',
    }),
    headerHeight() {
      return this.$vuetify.breakpoint.sm ? 'auto' : '88';
    },
    isEventsSearchPage() {
      return this.$route.name === 'events-search';
    },
    isEventLandingPage() {
      return this.$route.name === 'event-landing-redesign';
    },
    isExhibitionsPage() {
      return this.$route.name === 'event-exhibition';
    },
  },
  watch: {
    '$route.path': {
      handler() {
        this.showSearchEventsField = false;
      },
    },
  },
  created() {},
  methods: {
    ...mapActions({
      logout: 'auth/logout',
    }),
    switchShowSearchEventsField() {
      this.showSearchEventsField = !this.showSearchEventsField;
      if (this.isEventsSearchPage) {
        this.showSearchEventsField = false;
      }
    },
    onAccountExit() {
      this.$dialogs.confirm({
        attrs: {
          method: this.onLogout,
          isRequest: false,
          message: 'Вы уверены, что хотите выйти из учётной записи?',
          closeBtnAttrs: {
            'btn-text': 'Остаться',
          },
          confirmBtnAttrs: {
            'btn-text': 'Выйти',
          },
        },
      });
    },
    async onLogout() {
      await this.logout();
      this.$router.push('/');
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  min-height: 88px;
  padding-top: 12px;
  z-index: 100 !important;
  background-color: #{$redesignControlsBackground} !important;
  // border-bottom: 1px solid #{$primary};

  &.sticky {
    position: sticky;
    top: 0;
  }

  .container {
    transition: all 0.5s ease-in-out;
  }

  @media (max-width: 601px) {
    height: auto;
    padding-top: 12px !important;
    min-height: 88px;
  }

  &__wrap {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    column-gap: 55px;

    @media (max-width: 991px) {
      column-gap: 20px;
    }

    @media (max-width: 601px) {
      flex-direction: column;
      align-items: flex-start;
      column-gap: 0;
      row-gap: 16px;
    }
  }

  &__logo-wrap--sm {
    gap: 4px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}

::v-deep .v-toolbar__content {
  padding: 0 !important;
  height: 88px !important;

  @media (max-width: 600px) {
    height: auto !important;
  }
}

::v-deep .profile__activator {
  padding: 0 8px;
}
</style>
